import React, { ReactElement, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import arrow from '@assets/arrow.png';
import Picker from './components/picker/Picker';
import { getPrivatePlieInfo } from '../../../../api/filling-pile';
import './index.less';
const ServiceHelp = (): ReactElement => {
  const router = useHistory();
  const [showPicker, setShowPicker] = useState<boolean>(false);
  const [equipmentCode, setEquipmentCode] = useState();
  const [pileInfo, setPileInfo] = useState<any>();
  const [homeCharge, setHomeCharge] = useState<any>();
  const setTitle = () => {
    document.title = '家充帮助中心';
  }
  const gotoFirstPile = () => {
    window.location.href = pileInfo.v1OperationIntroductionUrl;
  };
  const gotoSecondPile = () => {
    window.location.href = pileInfo.v2OperationIntroductionUrl;
  };
  const gotoSecondPlusPile = () => {
    window.location.href = pileInfo?.v2PlusOperationIntroductionUrl;
  };
  const gotoInstructions = (versionType) => {
    if (versionType === 1) {
      window.location.href = pileInfo.v1OperationIntroductionUrl;
      return;
    }
    window.location.href = pileInfo.v2OperationIntroductionUrl;
  };
  const gotoAfterSales = () => {
    router.push({
      pathname: '/after-sales',
      search: '?equipmentCode=' + (equipmentCode ? equipmentCode : '')
    });
  };
  const isInstructions = () => {
    // if (
    //   homeCharge?.piles[0]?.versionType === 0 ||
    //   homeCharge?.piles[0]?.versionType == null
    // ) {
      return setShowPicker(true);
    // }
    // gotoInstructions(homeCharge?.piles[0]?.versionType);
  };
  useEffect(() => {
    setTitle();
    getPrivatePlieInfo().then(res => {
      console.log(res);
      setHomeCharge(res);
      setEquipmentCode(res.piles[0]?.equipNo);
      setPileInfo(res.introductionConfig);
    });
  }, []);
  return (
    <div className="service-help">
      <div className="content">
        <div className="instructions">
          <div className="top" onClick={isInstructions}>
            <div className="title">使用说明书</div>
            <div className="arrow">
              <img src={arrow} alt="" className="open" />
            </div>
          </div>
        </div>
        <div className="instructions">
          {pileInfo && pileInfo?.qaIntroductionUrl?.map((path, index) => (
            <img src={path} alt="" key={index} className="installImg" />
          ))}
        </div>
      </div>
      <div className="footer">
        <button
          className='submitBtn'
          onClick={gotoAfterSales}
        >
          无法解决，申请售后
        </button>
      </div>
      <Picker
        show={showPicker}
        render={() => (
          <div className="pile-item">
            <div className="one" onClick={gotoFirstPile}>
              1.0充电桩
            </div>
            <div className="two" onClick={gotoSecondPile}>
              2.0充电桩
            </div>
            <div className="twoPlus" onClick={gotoSecondPlusPile}>
              2.0 PLUS 充电桩
            </div>
          </div>
        )}
        onSure={() => setShowPicker(false)}
        onCancel={() => setShowPicker(false)}
      />
    </div>
  );
};
export default ServiceHelp;
